// Import from Primer once available

const UnwrapIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" aria-hidden="true">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M1 13h3M1 8h14M1 3h14"
    />
  </svg>
)

export default UnwrapIcon

try{ UnwrapIcon.displayName ||= 'UnwrapIcon' } catch {}